import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

// components
import DataTable from '../../../juristec-ui/core/DataTable';
import Avatar from '../../../juristec-ui/core/Avatar';
import Tooltip from '../../../juristec-ui/core/Tooltip';
import TablePagination from '../../../juristec-ui/core/TablePagination';

// styled
import {
  Container,
  Infos,
  StyledFont,
  FilesList,
  KpisCount,
  EmptyList,
  UpdateDateContainer,
  UpdatedByContainer,
  DashboardNameContainer,
} from './styled/DashboardDependencies.styled';

//utils
import { formatDateTime } from '../../../juristec-ui/utils/functions/lab';

function DashboardDependencies({
  currentUser,
  dashboard,
  files,
  users,
  numberOfKpis,
  close,
  deviceType,
}) {
  const [page, setPage] = useState(0);

  // const dashsNames = Object.keys(file.dashboards || {});
  // const dashsArray = [];
  // Object.keys(file.dashboards).forEach((key) => dashsArray.push({
  //   dashId: key,
  //   ...file.dashboards[key],
  // }));
  const theme = useTheme();

  const getOwnerAvatar = (ownerId) => {
    const userOwner = users.filter((user) => user.id === ownerId);
    if (userOwner.length === 1) {
      return (
        <Tooltip text={userOwner[0].name || ''} direction="right">
          <Avatar
            name={userOwner[0].name || ''}
            src={userOwner[0].photoUrl || ''}
            size="medium"
            onClick={(e) => e.stopPropagation()}
            style={{ cursor: 'default' }}
          />
        </Tooltip>
      );
    }
    return null;
  };

  const getUpdateDate = (file) => (file.updated_at || file.updatedBy ? (
    <UpdateDateContainer>
      {file.updated_at && (
        <span>{formatDateTime(file.updated_at, { time: 'none' })}</span>
      )}
      {!!file.updatedBy && (
        <UpdatedByContainer>
          {users.filter((u) => u.uid === file.updatedBy)}
        </UpdatedByContainer>
      )}
    </UpdateDateContainer>
  ) : '-');

  const columns = [
    {
      field: 'owner',
      label: '',
      valueGetter: (param) => getOwnerAvatar(param.owner),
    },
    {
      field: 'name',
      label: 'Arquivo',
      valueGetter: (param) => `${param.filename}${param.allowed ? '' : '*'}`,
      sortable: true,
    },
    deviceType === 'desktop' ? {
      field: 'created_at',
      label: 'Criado em',
      valueGetter: (param) => (param.created_at ? formatDateTime(param.created_at, { time: 'none' }) : '-'),
      sortable: true,
    } : {},
    deviceType === 'desktop' ? {
      field: 'updatedAt',
      label: 'Atualizado em',
      valueGetter: (param) => getUpdateDate(param),
      sortable: true,
    } : {},
  ];

  return (
    <Container>
      <Infos>
        <StyledFont>
          {dashboard.name}
        </StyledFont>
        <KpisCount>
          <span>
            KPI's:
          </span>
          {' '}
          <StyledFont>
            {numberOfKpis || 0}
          </StyledFont>
        </KpisCount>
      </Infos>
      <FilesList>
        {files.length > 0 ? (
          <>
            <DataTable
              columns={columns}
              rowData={files}
              rowColor={theme.tableBackground}
              strippedRowsColor={theme.containerOdd}
              defaultSortField="name"
              headerColor="transparent"
              theadStyle={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                backgroundColor: theme.background,
              }}
              usePagination
              page={page}
              itemsPerPage={5}
            />
            <TablePagination
              page={page}
              setPage={setPage}
              totalPages={
                Math.floor(files.length % 5 === 0
                  ? (files.length / 5) - 1
                  : files.length / 5)
              }
            />
          </>
        ) : (
          <EmptyList>
            Este dashboard ainda não utilizou nenhum arquivo para a construção de KPI's.
          </EmptyList>
        )}
      </FilesList>
    </Container>
  );
}

DashboardDependencies.propTypes = {
  /**
   * Object with the currentUser information.
  * */
  currentUser: PropTypes.shape({
    uid: PropTypes.string,
  }).isRequired,
  /**
   * Object with the dashboard data.
  * */
  dashboard: PropTypes.shape({
    name: PropTypes.string,
    databases: PropTypes.arrayOf(
      PropTypes.string,
    ),
  }).isRequired,
  /**
   * Array of the files data.
  * */
  files: PropTypes.arrayOf(
    PropTypes.shape({
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      lastUpdateUser: PropTypes.string,
      filename: PropTypes.string,
    }),
  ).isRequired,
  /**
   * Object with the list of users from the instance.
  * */
  users: PropTypes.arrayOf(
    PropTypes.shape({}).isRequired,
  ).isRequired,
  /**
   * Number of KPI's in the dashboard.
   */
  numberOfKpis: PropTypes.number,
  /**
   * Function to close the modal.
   */
  close: PropTypes.func,
  /**
   * The current device type by viewport width
   */
  deviceType: PropTypes.string.isRequired,
};

DashboardDependencies.defaultProps = {
  close: () => {},
  numberOfKpis: 0,
};

export default DashboardDependencies;
